'use client'

import clsx from 'clsx'
import styles from './styles.module.scss'

interface BadgeProps {
  used: string
}

const BADGE_LABELS: Record<string, string> = {
  sidenav: '新着あり',
}

export default function Badge({ used }: BadgeProps) {
  return <span className={clsx(styles.badge, styles[used])}>{BADGE_LABELS[used]}</span>
}
